/**
 * LA JAUGE — une réglure d'encre, pas un dégradé fluo.
 *
 * Elle porte TOUJOURS son nombre à côté d'elle : à quatre PV près, la longueur d'une barre ne se
 * lit pas, et dans un jeu où l'on meurt pour de bon, « il me reste combien ? » doit avoir une
 * réponse chiffrée. Les crans tous les quarts donnent l'échelle sans graduation chiffrée.
 */
interface Props {
  valeur: number;
  maximum: number;
  espece: "pv" | "essence";
  largeur?: number;
}

export function Jauge({ valeur, maximum, espece, largeur = 160 }: Props) {
  const hauteur = 12;
  const plein = maximum > 0 ? Math.max(0, Math.min(1, valeur / maximum)) : 0;

  return (
    <svg className="jauge" viewBox={`0 0 ${largeur} ${hauteur}`} width={largeur} height={hauteur} aria-hidden="true">
      <rect className="jauge__cadre" x="0.5" y="0.5" width={largeur - 1} height={hauteur - 1} />
      <rect
        className={`jauge__remplissage jauge__remplissage--${espece}`}
        x="1"
        y="1"
        width={Math.max(0, (largeur - 2) * plein)}
        height={hauteur - 2}
      />
      {/* Les crans du quart : l'échelle se lit sans qu'on écrive un seul chiffre dessus. */}
      {[0.25, 0.5, 0.75].map((part) => (
        <line key={part} className="jauge__cran" x1={largeur * part} y1="1" x2={largeur * part} y2={hauteur - 1} />
      ))}
    </svg>
  );
}
